"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgSharedBathroom = function SvgSharedBathroom(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    stroke: "#4D4D4D",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.589 19.466h3.875a4 4 0 0 0 4-4v-2.96M12 1.037v21.882M13.589 10.5h7.918a1 1 0 0 1 1 1v.006a1 1 0 0 1-1 1h-7.918m-11.061 0v3.01a4 4 0 0 0 4 4h3.911M10.5 10.5H2.496a1 1 0 0 0-1 1v.006a1 1 0 0 0 1 1H10.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.516 19.48a2.03 2.03 0 0 1-2.03 2.03h-.45m13.437-2.03c0 1.122.91 2.03 2.03 2.03h.45"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgSharedBathroom);
var _default = exports["default"] = Memo;